import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { wrap } from '@hilma/tools';
import { campaign_params } from '../constants/campaignParams';
import axios from 'axios';

export const PathOptionsContext = createContext<Record<string, any> | null>(null);
export const SetPathOptionsContext = createContext<React.Dispatch<React.SetStateAction<Record<string, any>>> | null>(null);

const PathOptionsProvider: React.FC = ({ children }) => {
    const [pathOptions, setPathOptions] = useState<Record<string, any>>({});

    const location = useLocation();

    useEffect(() => {
        try {
            const urlSearchParams = new URLSearchParams(location.search);

            let pathOptions: Record<string, any> = {};
            let campaign: { [params: string]: string } = {}

            for (const [key, value] of urlSearchParams) {
                pathOptions[key] = value;
                if (campaign_params.includes(key))
                    campaign[key.replace('utm_', '')] = value;

            }

            if (Object.keys(campaign).length === campaign_params.length) {
                try {
                    axios.post('/api/campaign/entry', campaign)
                    sessionStorage.setItem('ads', JSON.stringify(campaign));
                    pathOptions = { ...pathOptions, ...campaign };
                } catch (error) { }
            }
            else if (!campaign.content) {
                let from_session = sessionStorage.getItem('ads');

                if (from_session)
                    try {
                        campaign = JSON.parse(from_session);
                        pathOptions = { ...pathOptions, ...campaign };
                    }
                    catch (err) { }
            }

            setPathOptions(pathOptions);

        } catch (err) { }
    }, []);

    return wrap(
        [PathOptionsContext.Provider, { value: pathOptions }],
        [SetPathOptionsContext.Provider, { value: setPathOptions }]
    )(children) as React.ReactElement;
}

export default PathOptionsProvider;